import { useState } from "react";
import onboardingGif from "@assets/pulse/onboarding.gif";
import { useHideComponents } from "@hooks/useHideComponents";

/** Pulse Onboarding screen for pulse variant manual */
const PulseMobileOnboarding = (): React.ReactElement => {
  const [isShowOnBoarding, setIsShowOnBoarding] = useState(true);
  const { isHide } = useHideComponents(5000);

  const handleOnboardingClose = () => {
    setIsShowOnBoarding(false);
  };

  if (!isShowOnBoarding || isHide) return <></>;

  return (
    <div
      className="fixed inset-0 z-20 flex h-full w-full items-center justify-center bg-black/50"
      onClick={handleOnboardingClose}
      data-testid="pulse-mobile-onboarding-component"
    >
      <div className="mx-auto w-full max-w-[200px]">
        <img
          src={onboardingGif}
          alt="onboarding gif"
          width={200}
          height={200}
        />
      </div>
    </div>
  );
};

export default PulseMobileOnboarding;
